import request from '@/utils/request'
import { formatParam } from '@/utils/tool'

// 获取 七牛云 上传文件的token
export function uploadToken (params: {
  fileName: string;
  fileSize: number;
  objectId: number;
  objectType: string;
  saasId?: number
}): any {
  return request(`/saas/upload/file/token?${formatParam(params)}`)
}

// 文件上传成功时调用 通知
export function fileSuccess (params: {
  id : string;
  saasId?: number
}): any {
  return request(`/saas/upload/file/success?${formatParam(params)}`, {
    method: 'PATCH'
  })
}
